import React from "react"

import styled from "styled-components"
import { Link } from "gatsby"
const data = [
  {
    id: 1,
    text: "home",
    url: "/",
    cls: "",
  },
  {
    id: 2,
    text: "about",
    url: "/about/",
    cls: "",
  },
  {
    id: 3,
    text: "projects",
    url: "/projects/",
    cls: "",
  },
  {
    id: 4,
    text: "blog",
    url: "/blog/",
    cls: "",
  },
  {
    id: 5,
    text: "contact",
    url: "/contact/",
    cls: "contact",
  },
]

export default ({ styleClass }) => {
  return (
    <UnOrderList className={`page-links ${styleClass ? styleClass : ""}`}>
      {data.length > 0 &&
        data.map(link => (
          <li key={link.id} className={link.cls}>
            <Link to={link.url}>{link.text}</Link>
          </li>
        ))}
    </UnOrderList>
  )
}

export const UnOrderList = styled.ul`
  &.nav-links {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1rem;
    padding: 0 1rem;

    & li {
      margin: 0 auto;
      padding: 0;
      display: flex;
      align-items: center;
      padding: 0 0.3rem;
      height: 100%;

      & a {
        text-transform: capitalize;
        color: var(--clr-primary-5);
        font-size: 0.85rem;
        letter-spacing: var(--spacing);
        transition: var(--transition);
        padding: 0.5rem 0.2rem;

        &:hover,
        &:focus {
          font-size: 0.87rem;
          font-weight: bold;
          color: var(--clr-primary-5);
          box-shadow: 0px 2px var(--clr-primary-5);
        }
      }

      &.contact {
        background: transparent;
        color: var(--clr-primary-5);
        padding: 0 0.2rem;
        letter-spacing: var(--spacing);
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 700;
        -webkit-transition: var(--transition);
        transition: var(--transition);
        font-size: 0.875rem;
        border: 2px solid var(--clr-primary-5);
        cursor: pointer;
        box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
        border-radius: 0 0 12px 0;

        &:hover {
          color: var(--clr-primary-1);
          background: var(--clr-primary-8);
        }
      }
    }
    @media (max-width: 768px) {
      display: none;
    }
  }

  &.sidebar-links2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 2rem;
    padding: 2rem;
    width: 80%;
    height: 80%;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 0 0 10% 0;

    & li {
      width: 100%;
      height: 80%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    & a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80%;
      text-align: center;
      text-transform: capitalize;
      color: white;
      letter-spacing: var(--spacing);
      margin-bottom: 0.5rem;
      margin-right: auto;
      margin-left: auto;
      padding: 0.3rem 1rem;
      font-size: 1.2rem;
      transition: var(--transition);
      border-radius: var(--radius);
    }
    & .contact {
      width: 80%;
      padding: 0.2rem 1rem;
      background: transparent;
      border: 2px solid var(--clr-primary-5);
      border-radius: 0 0 12px 0;

      &:hover {
        background: var(--clr-primary-9);
        color: var(--clr-primary-5);
      }
    }
    & li:not(:last-child) a:hover {
      background: var(--clr-primary-9);
      color: var(--clr-primary-5);
    }
    @media (min-width: 786px) {
      display: none;
    }
  }
`
